var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, observable } from 'mobx';
import { api } from 'helpers/Api';
import Device from './Model';
export default class default_1 {
    constructor() {
        this.data = [];
        this.loaded = false;
        this.set = (values) => {
            console.log('Devices-Store - set - values: ', values);
            this.data = values.map(value => new Device(value));
            this.loaded = true;
            return this.data;
        };
    }
    read(id) {
        if (id)
            return api.get('devices' + id);
        return api.get('devices').then(value => {
            return this.set(value);
        });
    }
}
__decorate([
    observable
], default_1.prototype, "data", void 0);
__decorate([
    observable
], default_1.prototype, "loaded", void 0);
__decorate([
    action
], default_1.prototype, "set", void 0);



//////////////////
// WEBPACK FOOTER
// ./src/modules/Devices/Store.ts
// module id = 352
// module chunks = 0